import React from 'react';
import { motion } from 'framer-motion';

// Team Images
import gnaho from '../img/team/gnaho.png';
import chandouri from '../img/team/chandouri.png';
import chaumat from '../img/team/chaumat.png';
import carre from '../img/team/carre.png';
import girard from '../img/team/girard.png';

// SAB Images
import peters from '../img/team/peters.png';
import capuzzo from '../img/team/capuzzo.png';
import ginestier from '../img/team/ginestier.png';
import charafe from '../img/team/charafe.png';

const leadership = [
  {
    name: "Dr Sylvain GNAHO",
    role: "President",
    bio: "Dental Surgeon, Sylvain holds a Harvard Certificate in Technology Entrepreneurship, a Dental Thesis on Cancer Stem Cells in Head & Neck cancers, a Master’s Degree in Medical Law, and a university degree in Biology.",
    linkedin: "https://www.linkedin.com/in/sylvain-g-290b9a36/",
    image: gnaho
  },
  {
    name: "Pierre CHAUMAT",
    role: "CEO",
    bio: "Biologist, experienced executive veteran of startups and larger companies in life sciences and Diagnostics, director of large R&D teams.",
    linkedin: "https://www.linkedin.com/in/pierre-chaumat-3321b86/?skipRedirect=true",
    image: chaumat
  },
  {
    name: "Dr Boutaîna CHANDOURI-FAIZE",
    role: "CTO",
    bio: "PhD on cancer stem cell (CSC) biology in non-small cell lung cancer, the scientist behind the clinical relevance of glycan motifs for CSC detection, leading to a first-author publication in the British Journal of Cancer.",
    linkedin: "https://www.linkedin.com/in/bouta%C3%AEna-chandouri-faize-b53225159/?skipRedirect=true",
    image: chandouri
  },
  {
    name: "Dr Vincent CARRE",
    role: "CSO",
    bio: "Biotech entrepreneur with over 25 years of experience in oncology, founder and CEO of several award-winning biotechs, combined strong scientific expertise in glycosylation.",
    linkedin: "https://www.linkedin.com/in/vincent-carr%C3%A9-0425422a/?skipRedirect=true",
    image: carre
  },
  {
    name: "Pr Nicolas GIRARD",
    role: "Chief Medical Advisor",
    bio: "Head of Department of Medical Oncology, thoracic oncologist at Institut Curie, specialized in lung cancer and advanced therapies.",
    linkedin: "https://www.linkedin.com/in/nicolas-girard-b9003298/",
    image: girard
  }
];

const sab = [
  {
    name: "Pr Nicolas GIRARD",
    role: "Chair",
    bio: "Head of Department of Medical Oncology, thoracic oncologist at Institut Curie, specialized in lung cancer and advanced therapies.",
    linkedin: "https://www.linkedin.com/in/nicolas-girard-b9003298/",
    image: girard
  },
  {
    name: "Pr Solange PETERS",
    role: "Member",
    bio: "Chair Medical Oncology and Thoracic cancer Clinic at CHUV Lausanne Full Professor Lausanne University, ESMO President 2020-2022.",
    linkedin: "https://www.linkedin.com/in/peters-solange-10766bb/",
    image: peters
  },
  {
    name: "Pr Federico CAPPUZZO",
    role: "Member",
    bio: "Director of Medical Oncology at the National Cancer Institute Regina Elena. Renowned oncologist and Lung cancer Expert.",
    linkedin: "https://www.linkedin.com/in/federico-cappuzzo-27353979/",
    image: capuzzo
  },
  {
    name: "Dr Christophe GINESTIER",
    role: "Member",
    bio: "Co-Chair of the CoMET Department, Head of the Epithelial Stem Cells and Cancer Lab at CRCM Centre de Recherche en Cancérologie de Marseille.",
    linkedin: "https://www.linkedin.com/in/christophe-ginestier-91253713/",
    image: ginestier
  },
  {
    name: "Pr Emmanuelle CHARAFE-JAUFFRET",
    role: "Member",
    bio: "Professor at Marseille medical faculty and pathologist at Institut Paoli Calmettes, specialized in breast cancer. MD and PhD in breast cancer stem cells research.",
    linkedin: "https://www.linkedin.com/in/charafe-jauffret-emmanuelle-05a26362/",
    image: charafe
  }
];

const TeamMemberCard = ({ member }) => (
  <motion.div 
    className="w-full md:w-80 flex-shrink-0 bg-white border border-gray-200 rounded-xl p-6 shadow-sm flex flex-col items-center text-center"
    whileHover={{ y: -5 }}
    transition={{ duration: 0.2 }}
  >
    <a href={member.linkedin} target="_blank" rel="noopener noreferrer" className="block mb-6 relative group">
      {member.image ? (
        <img 
          src={member.image} 
          alt={member.name} 
          className="w-32 h-32 rounded-full object-cover border-4 border-ninsun-surface group-hover:border-ninsun-gold transition-colors"
        />
      ) : (
        <div className="w-32 h-32 rounded-full bg-gray-200 flex items-center justify-center border-4 border-ninsun-surface group-hover:border-ninsun-gold transition-colors text-gray-400 font-bold text-3xl">
          {member.name.charAt(0)}
        </div>
      )}
      <div className="absolute inset-0 bg-black/50 rounded-full opacity-0 group-hover:opacity-100 flex items-center justify-center transition-opacity">
        <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/></svg>
      </div>
    </a>
    <h4 className="text-xl font-bold text-ninsun-text mb-1">{member.name}</h4>
    <p className="text-ninsun-gold font-mono text-sm tracking-wide mb-4">{member.role}</p>
    <p className="text-ninsun-muted text-sm leading-relaxed">{member.bio}</p>
  </motion.div>
);

const TeamSection = () => {
  return (
    <section id="team" className="py-20 md:py-32 relative bg-white">
      <div className="container mx-auto px-6">
        
        <div className="mb-20">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-display font-bold text-ninsun-text mb-4 tracking-tight">The Leadership Team</h2>
          </div>
          <div className="flex flex-wrap justify-center gap-8 max-w-6xl mx-auto">
            {leadership.map((member, idx) => (
              <TeamMemberCard key={idx} member={member} />
            ))}
          </div>
        </div>

        <div>
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-display font-bold text-ninsun-text mb-4 tracking-tight">Our Scientific Advisory Board</h2>
          </div>
          <div className="flex flex-wrap justify-center gap-8 max-w-6xl mx-auto">
            {sab.map((member, idx) => (
              <TeamMemberCard key={idx} member={member} />
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default TeamSection;